import { createContext, useEffect, useState } from 'react';
import * as React from 'react';
import {
  IPaginate,
  TChannel,
  TProject,
  TSpace,
  TChannelMembersCounts,
} from '../models/common';
import dbService from 'services/database.service';
import { localStorageService, STORAGE_KEY } from 'services/local-storage.service';

interface IProjectContext {
  projectData: TProject | undefined;
  setProjectData: React.Dispatch<React.SetStateAction<TProject | undefined>>;
  channels: TChannel[];
  setChannels: React.Dispatch<React.SetStateAction<TChannel[]>>;
  channelsMembersCounts: TChannelMembersCounts[];
  setChannelsMembersCounts: React.Dispatch<React.SetStateAction<TChannelMembersCounts[]>>;
}

export const ProjectContext = createContext<IProjectContext>({
  projectData: undefined,
  setProjectData: (value: any) => undefined,
  channels: [],
  setChannels: (value: any) => undefined,
  channelsMembersCounts: [],
  setChannelsMembersCounts: (value: any) => undefined,
});

export const ProjectContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [projectData, setProjectData] = useState<TProject>();
  const [channels, setChannels] = useState<TChannel[]>([]);
  const [channelsMembersCounts, setChannelsMembersCounts] = useState<TChannelMembersCounts[]>([]);

  useEffect(() => {
    initializeData();
  }, []);

  const initializeData = async () => {
    const projectDataRes = await dbService.getProject().catch(console.error);
    if(!projectDataRes) return;

    setProjectData(projectDataRes);
    localStorageService.setItem(STORAGE_KEY.PROJECT_ID, projectDataRes._id!);

    const channels = await dbService.getChannels({ relation: true });
    setChannels(channels);

    await getSpacesMembersCounts(channels);
  };

  const getSpacesMembersCounts = async (_channels: TChannel[]) => {
    const result: TChannelMembersCounts[] = [];
    const promises = [];
    for (const channel of _channels) {
      promises.push(
        dbService.getSpaces({ filter: { channel: channel._id }, limit: 1, paginate: true })
      );
    }

    const res = await Promise.all(promises).catch(console.error);
    if (!res) return;

    res.forEach((el) => {
      const { data, meta } = el as unknown as IPaginate<TSpace>;
      if (data.length) {
        result.push({ id: data[0].channel!, count: meta.total });
      }
    });

    setChannelsMembersCounts(result);
  };

  return (
    <ProjectContext.Provider
      value={{
        projectData,
        setProjectData,
        channels,
        setChannels,
        channelsMembersCounts,
        setChannelsMembersCounts,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};
